// Auto-generated phrase index - imports all language packs
import spanish from './spanish';
import french from './french';
import portuguese from './portuguese';
import german from './german';
import italian from './italian';
import thai from './thai';
import vietnamese from './vietnamese';
import japanese from './japanese';
import arabic from './arabic';
import mandarin from './mandarin';

const allPhrases = {
  spanish,
  french,
  portuguese,
  german,
  italian,
  thai,
  vietnamese,
  japanese,
  arabic,
  mandarin,
};

export default allPhrases;
